'use strict';

var React = require('react');

var SvgBlankFilledIcon = function SvgBlankFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6.25c0-1.519-1.231-2.75-2.75-2.75h-1c-.414 0-.75.336-.75.75s.336.75.75.75h1c.69 0 1.25.56 1.25 1.25v1c0 .414.336.75.75.75s.75-.336.75-.75v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 16.5c-1.519 0-2.75-1.231-2.75-2.75v-1c0-.414.336-.75.75-.75s.75.336.75.75v1c0 .69.56 1.25 1.25 1.25h1c.414 0 .75.336.75.75s-.336.75-.75.75h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 16.5c1.519 0 2.75-1.231 2.75-2.75v-1c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1c0 .69-.56 1.25-1.25 1.25h-1c-.414 0-.75.336-.75.75s.336.75.75.75h1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 3.5c-1.519 0-2.75 1.231-2.75 2.75v1c0 .414.336.75.75.75s.75-.336.75-.75v-1c0-.69.56-1.25 1.25-1.25h1c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 6.5c-.966 0-1.75.784-1.75 1.75v3.5c0 .966.784 1.75 1.75 1.75h3.5c.966 0 1.75-.784 1.75-1.75v-3.5c0-.966-.784-1.75-1.75-1.75h-3.5Z"
  }));
};
SvgBlankFilledIcon.displayName = "BlankFilledIcon";

exports.SvgBlankFilledIcon = SvgBlankFilledIcon;
